import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from "components/common/ApiUrl";
import { RootState } from "redux/store";

// re-send interfaces and Details here //
interface ReSendVerificationState {
  reSendList: any[];
  isLoading: boolean;
  error: string | null;
}

interface ReSendVerificationCredentials {
  email: string;
}

interface ReSendVerificationPayload {
  credentials: ReSendVerificationCredentials;
  subdomain: string;
}

interface ReSendVerificationSuccessResponse {
  token: string;
  db_token: string;
  message?: string;
}

interface ReSendVerificationRejectedValue {
  message: string;
  status: number;
}

const initialState: ReSendVerificationState = {
  reSendList: [],
  isLoading: false,
  error: null,
};


// Re-Send verification Async here //
export const reSendVerificationAsync = createAsyncThunk<
ReSendVerificationSuccessResponse,
ReSendVerificationPayload,
  { rejectValue: ReSendVerificationRejectedValue }
>(
  "re-send/verification",
  async (
    { credentials, subdomain }: ReSendVerificationPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {},
      };

      if (subdomain) {
        config.headers["sub-domain"] = subdomain;
      }

      const response = await axios.post(
        `${API_BASE_URL}/send-reverification-link`,
        credentials,
        config
      );
      console.log(response,"response")

      if (response.data.success) {
        const data: ReSendVerificationSuccessResponse = {
          token: response?.data?.data?.token,
          db_token: response?.data?.data?.db_token,
          message: response?.data?.message, 
        };

        if (subdomain) {
          localStorage.setItem("subdomain", subdomain);
        } else {
          localStorage.setItem("subdomain", "");
        }

        const tokenKey = subdomain ? "client_token" : "token";
        const dbTokenKey = subdomain ? "client_db_token" : "db_token";

        localStorage.setItem(tokenKey, data?.token);
        localStorage.setItem(dbTokenKey, data?.db_token);

        return data;
      } else {
        return rejectWithValue({
          message: response.data.message,
          status: response.data.status,
        });
      }
    } catch (error: any) {
      const errorResponse = error.response?.data || {};
      const errorMessage =
        errorResponse.message || "An error occurred during re-send verification link";
      return rejectWithValue({
        message: errorMessage,
        status: errorResponse.status || 500,
      });
    }
  }
);

// Re-send Slice here //

export const reSendVerificationSlice = createSlice({
  name: "reSendVerificationState",
  initialState,
  reducers: {
    reSendVerificationData: (state, action: PayloadAction<any>) => {
      state.reSendList.push(action.payload);
    },
    resetList: () => initialState,
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reSendVerificationAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        reSendVerificationAsync.fulfilled,
        (state, action: PayloadAction<ReSendVerificationSuccessResponse>) => {
          state.isLoading = false;
          state.reSendList.push(action.payload);
        }
      )
      .addCase(
        reSendVerificationAsync.rejected,
        (state, action: PayloadAction<ReSendVerificationRejectedValue | undefined>) => {
          state.isLoading = false;
          state.error = action.payload?.message;
        }
      );
  },
});

// Selectors here //
export const { resetList, reSendVerificationData, clearError } = reSendVerificationSlice.actions;

export default reSendVerificationSlice.reducer;

export const selectedReSendVerificationDataList = (state: RootState) =>
  state.reSendVerificationState?.reSendVerificationList ?? [];
